import './scoped_drawer.scss';

import classnames from 'classnames';
import {
  arrayOf,
  elementType,
  func,
  node,
  object,
  shape,
  string,
} from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { GoLinkExternal } from 'react-icons/go';
import { Link, withRouter } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const URL_VALUES = {
  open: 'open',
  expanded: 'expanded',
  closed: undefined,
};

class ScopedDrawer extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggleOff = this.handleToggleOff.bind(this);
  }

  // Can only toggle off, because isOpen is hard-coded to true
  handleToggleOff() {
    const { options, location, history } = this.props;
    const search = qs.parse(location.search);
    const expandedOption = options.find(
      option => search[option.key] === URL_VALUES.expanded,
    );

    history.push(this.getLinkTarget(search, expandedOption, URL_VALUES.closed));
  }

  getLinkTarget(search, option, value) {
    const { location } = this.props;
    return {
      pathname: location.pathname,
      search: qs.stringify({ ...search, [option.key]: value }),
    };
  }

  renderModal(search, expandedOption) {
    if (!expandedOption) return null;
    const ContentComponent = expandedOption.contentComponent;

    return (
      <Modal isOpen toggle={this.handleToggleOff} size="lg">
        <ModalHeader toggle={this.handleToggleOff}>
          {expandedOption.label}
        </ModalHeader>
        <ModalBody>
          <ContentComponent
            key={expandedOption.key}
            {...expandedOption.props}
          />
        </ModalBody>
      </Modal>
    );
  }

  renderDrawerContent(search, openOption) {
    if (!openOption) return null;
    const ContentComponent = openOption && openOption.contentComponent;

    return (
      <div className="c-scoped-drawer__content" id="qa-comments">
        {openOption.expandable && (
          <Link
            className="float-right"
            to={this.getLinkTarget(search, openOption, URL_VALUES.expanded)}
          >
            expand <GoLinkExternal />
          </Link>
        )}
        <h4 className="h5">{openOption.label}</h4>
        <ContentComponent key={openOption.key} {...openOption.props} />
      </div>
    );
  }

  renderToggles(search, selectedOption) {
    const { options } = this.props;

    return (
      <div className="c-scoped-drawer__toggles">
        {options.map(option => (
          <Link
            key={option.key}
            className={classnames('c-scoped-drawer__toggle text-dark', {
              active: option === selectedOption,
            })}
            to={this.getLinkTarget(
              search,
              option,
              option === selectedOption ? URL_VALUES.closed : URL_VALUES.open,
            )}
          >
            {option.label}
          </Link>
        ))}
      </div>
    );
  }

  render() {
    const { children, location, options } = this.props;
    const search = qs.parse(location.search);
    const closingSearch = { ...search };
    options.forEach(option => {
      closingSearch[option.key] = URL_VALUES.closed;
    });

    const openOption = options.find(
      option => search[option.key] === URL_VALUES.open,
    );
    const expandedOption = options.find(
      option => search[option.key] === URL_VALUES.expanded,
    );

    return (
      <div
        className={classnames('c-scoped-drawer', {
          'c-scoped-drawer--open': !!openOption,
        })}
      >
        <div className="c-scoped-drawer__scope">
          {children}
          <div className="c-scoped-drawer__drawer border-left">
            {this.renderDrawerContent(closingSearch, openOption)}
            {this.renderToggles(closingSearch, openOption || expandedOption)}
          </div>
        </div>
        {this.renderModal(closingSearch, expandedOption)}
      </div>
    );
  }
}

ScopedDrawer.propTypes = {
  children: node.isRequired,
  location: shape({ search: string }).isRequired,
  history: shape({ push: func.isRequired }).isRequired,
  options: arrayOf(
    shape({
      label: string.isRequired,
      key: string.isRequired,
      contentComponent: elementType.isRequired,
      props: object.isRequired, // eslint-disable-line react/forbid-prop-types
    }).isRequired,
  ).isRequired,
};

export default withRouter(ScopedDrawer);
